module.exports = __webpack_public_path__ + "img/hr-heat-pipe-corner-up-right-3.e06d517f.png";